"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ItemWithOffersFragment = (0, graphql_tag_1.default)(`
  fragment offers on ItemOffer {
    price
    listPrice
    currency
    exchangeRate
    idExchangeRate
    originalPriceForeign
    bestPrice {
      discount
      paymentMethodDescription
      paymentMethodId
      totalAmount
    }
    bestInstallmentPlan {
      discount
      installment
      installmentAmount
      interestAmount
      paymentMethodDescription
      paymentMethodId
      totalAmount
    }
    paymentMethods {
      id
      installmentPlans {
        discount
        installment
        installmentAmount
        interestAmount
        totalAmount
      }
    }
    restrictions {
      maxCheckoutQuantity
      timerStartDate
      timerEndDate
    }
    seller {
      address {
        address
        city
        complement
        country
        district
        number
        state
        zipcode
      }
      available
      deliveryDescription
      deliveryId
      description
      documentNumber
      id
      isActive
      isChatEnabled
      isIpdv
      isQuestionsAndAnswersEnabled
      legalName
      name
      regulatoryData {
        anvisa {
          items
          notApply
        }
        mapa {
          items
          notApply
        }
      }
      sellerSince
      sellsToCompany
      shippingDocumentNumber
      sku
      stats {
        answerRate {
          message
          status
        }
        deliveryRate {
          message
          status
        }
        score
        totalSales
      }
      tags {
        action {
          type
          url
        }
        backgroundColor
        code
        discountType
        discountValue
        endDate
        icon
        iconProperties {
          width
          height
          position
        }
        layout
        message
        startDate
        textColor
        type
        version
      }
    }
    badges {
      container
      imageUrl
      position
      slug
      text
      tooltip
    }
    promotions {
      id
      description
      benefit
      subBenefit
      benefitType
      benefitValue
      benefitPrice
      benefitBestPrice
    }
  }
`);
exports.default = ItemWithOffersFragment;
